export const slugify = (str: string) => {
  // Normalize and clean
  let result = str
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s-]/g, "");

  // Replace sequences of spaces, underscores, hyphens with single hyphen
  result = result.replace(/[\s_-]+/g, "-"); // This is also safe

  // Remove leading hyphens (string manipulation)
  let start = 0;
  while (start < result.length && result[start] === "-") {
    start++;
  }

  // Remove trailing hyphens (string manipulation)
  let end = result.length - 1;
  while (end >= 0 && result[end] === "-") {
    end--;
  }

  return start <= end ? result.slice(start, end + 1) : "";
};
